module.exports = __webpack_public_path__ + "img/bedroom_comp_001.06209ec0.jpg";